import {Availability} from '../../models/availability';
import {isFalsy} from './is_falsy';

export function isFullyUnavailable(availability: Availability) {
    return (
        isFalsy(availability.monday) &&
        isFalsy(availability.monday_morning) &&
        isFalsy(availability.tuesday) &&
        isFalsy(availability.tuesday_morning) &&
        isFalsy(availability.wednesday) &&
        isFalsy(availability.wednesday_morning) &&
        isFalsy(availability.thursday) &&
        isFalsy(availability.thursday_morning) &&
        isFalsy(availability.friday) &&
        isFalsy(availability.friday_morning)
    );
}
